export const sidebarArticleIconTokens = [
  "arrowRight",
  "bookOpen",
  "chevronRight",
  "externalLink",
  "fileText",
  "newspaper",
  "phone",
  "shieldCheck",
  "sparkles",
  "wrench",
  "heroArrowRight",
  "heroBookOpen",
  "heroChevronRight",
  "heroDocumentText",
  "heroNewspaper",
  "heroPhone",
  "heroSparkles",
  "heroWrenchScrewdriver",
] as const;

export type SidebarArticleIconToken = (typeof sidebarArticleIconTokens)[number];

export const sidebarArticleTokens = {
  colors: {
    background: "#ffffff",
    surface: "#ffffff",
    text: "#071735",
    textSoft: "#25334d",
    textMuted: "#536278",
    accent: "#075ed6",
    accentContrast: "#ffffff",
    border: "rgba(7, 23, 53, 0.11)",
    imageFallback: "#edf2f7",
    shadow: "0 18px 48px rgba(7, 23, 53, 0.1)",
    hoverShadow: "0 22px 54px rgba(7, 23, 53, 0.14)",
  },
  icons: {
    headerCta: "arrowRight",
    itemCta: "chevronRight",
    footerCta: "arrowRight",
    footer: "phone",
    fallback: "newspaper",
  },
  radius: {
    panel: 8,
    card: 8,
    media: 7,
    arrow: 999,
  },
  sizes: {
    maxWidth: 460,
    imageWidth: 126,
    imageHeight: 96,
    arrow: 34,
    footerIcon: 38,
  },
  spacing: {
    panel: 20,
    headerGap: 14,
    listGap: 14,
    cardGap: 14,
    cardPadding: 12,
    footerPaddingY: 13,
    footerPaddingX: 14,
  },
  typography: {
    fontFamily:
      'Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    title: {
      fontSize: 23,
      lineHeight: 1.15,
      fontWeight: 850,
      letterSpacing: 0,
    },
    description: {
      fontSize: 13,
      lineHeight: 1.45,
      fontWeight: 500,
      letterSpacing: 0,
    },
    headerCta: {
      fontSize: 12,
      lineHeight: 1,
      fontWeight: 800,
      letterSpacing: 0,
    },
    itemTitle: {
      fontSize: 15,
      lineHeight: 1.2,
      fontWeight: 850,
      letterSpacing: 0,
    },
    itemText: {
      fontSize: 12,
      lineHeight: 1.48,
      fontWeight: 500,
      letterSpacing: 0,
    },
    eyebrow: {
      fontSize: 10,
      lineHeight: 1,
      fontWeight: 850,
      letterSpacing: 0,
      textTransform: "uppercase" as const,
    },
    footerTitle: {
      fontSize: 12,
      lineHeight: 1.15,
      fontWeight: 850,
      letterSpacing: 0,
    },
    footerText: {
      fontSize: 11,
      lineHeight: 1.3,
      fontWeight: 500,
      letterSpacing: 0,
    },
    footerCta: {
      fontSize: 12,
      lineHeight: 1,
      fontWeight: 850,
      letterSpacing: 0,
    },
  },
  motion: {
    card: "box-shadow 180ms ease, transform 180ms ease, border-color 180ms ease, background-color 180ms ease",
    image: "transform 420ms ease, filter 420ms ease",
    arrow:
      "background-color 180ms ease, border-color 180ms ease, color 180ms ease, transform 180ms ease",
    icon: "transform 180ms ease",
  },
} as const;

export type SidebarArticleColorToken = keyof typeof sidebarArticleTokens.colors;
